import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const includes = ['Análisis de visajismo y estructura facial', 'Lavado spa con masaje capilar', 'Corte de precisión (Clásico o Moderno)', 'Ritual de toalla caliente', 'Perfilado con navaja libre', 'Exfoliación facial', 'Mini facial con mascarilla para puntos negros', 'Peinado con productos de alta gama'];
export function PremiumService() {
  return <section className="py-24 px-6 bg-charcoal-800 relative overflow-hidden" data-id="element-82">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gold-900/20 rounded-full blur-[120px] pointer-events-none" data-id="element-83" />

      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-84">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-85">
          {/* Text Content */}
          <motion.div className="w-full lg:w-1/2" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-86">
            <div className="inline-block border border-gold-500/30 px-4 py-1 rounded-full mb-6" data-id="element-87">
              <span className="text-gold-400 text-xs font-sans tracking-widest uppercase" data-id="element-88">
                Nuestro Producto Estrella
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-serif text-cream mb-6" data-id="element-89">
              El Corte <span className="text-gold-400 italic" data-id="element-90">MA PREMIUM</span>
            </h2>

            <div className="space-y-6 mb-8" data-id="element-91">
              <div data-id="element-92">
                <h3 className="text-xl font-serif text-cream mb-2" data-id="element-93">
                  ¿Para quién es?
                </h3>
                <p className="text-cream-muted font-light leading-relaxed" data-id="element-94">
                  Para el profesional que entiende que los detalles lo son todo.
                  Para el hombre que no busca un simple trámite, sino una
                  experiencia de cuidado personal superior.
                </p>
              </div>

              <div data-id="element-95">
                <h3 className="text-xl font-serif text-cream mb-4" data-id="element-96">
                  ¿Qué incluye?
                </h3>
                <p className="text-cream-muted font-light leading-relaxed mb-4" data-id="element-97">
                  Una transformación completa. Sea un fade moderno o un estilo
                  clásico impecable, este es el estándar de oro de nuestra casa:
                </p>
                <ul className="space-y-3" data-id="element-98">
                  {includes.map((item, index) => <li key={index} className="flex items-start gap-3 text-cream-muted font-light" data-id="element-99">
                      <Check className="text-gold-500 shrink-0 mt-0.5" size={18} data-id="element-100" />
                      <span data-id="element-101">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <a href="https://book.weibook.co/ma-barber-studio" target="_blank" rel="noopener noreferrer" className="inline-block bg-transparent border border-gold-500 text-gold-400 hover:bg-gold-500 hover:text-charcoal-900 font-semibold py-3 px-8 rounded-sm transition-all duration-300 uppercase tracking-wider text-sm w-full sm:w-auto text-center" data-id="element-102">
              Reservar MA Premium
            </a>
          </motion.div>

          {/* Image Content */}
          <motion.div className="w-full lg:w-1/2" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-103">
            <div className="relative" data-id="element-104">
              <div className="relative aspect-[4/5] overflow-hidden rounded-sm bg-charcoal-900" data-id="element-105">
                <img src="https://cdn.magicpatterns.com/uploads/9iLmK2nXhKxm1gFu8bw2tC/1000121928.jpg" alt="Barber performing a premium cut" className="w-full h-full object-cover opacity-90 hover:opacity-100 transition-opacity duration-500" data-id="element-106" />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/80 via-transparent to-transparent" data-id="element-107" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}